import React from 'react'
import { Stack } from '~/components/_layouts'
import { ActionPlanCard } from '../cards/ActionPlanCard'
import { SelectCoachCard } from '../cards/SelectCoachCard'
import { CoachMeetingsCard } from '../cards/CoachMeetingsCard'
import { NetworkingEventsCard } from '../cards/NetworkingEventsCard'
import { UpcomingWebinarsCard } from '../cards/UpcomingWebinarsCard'

export function Select() {
  return (
    <Stack
      spacing={8}
      className="[&_.recommended-card>.yns-typography]:text-white"
    >
      <SelectCoachCard
        className="select-coach-card"
        color="select"
        variant="flat"
      />
      <div className="grid gap-8 xl:grid-cols-[1fr_1fr]">
        <CoachMeetingsCard
          className="coach-meetings-card xl:col-span-2 2xl:col-span-1"
          color="secondary"
          variant="flat"
        />
        <ActionPlanCard
          className="action-plan-card xl:col-span-2 2xl:col-span-1"
          color="select-secondary"
          variant="flat"
          progressVariant="SelectProgressbar"
          isSecondary={true}
        />
      </div>
      <NetworkingEventsCard
        className="networking-events-card"
        color="secondary"
        variant="flat"
      />
      <UpcomingWebinarsCard />
    </Stack>
  )
}
